export default "__VITE_ASSET__AP9ubQ0C__"